// Check if we're in production
const isProduction = window.location.hostname !== 'localhost';
const HOTJAR_ID = '5254175'; // Hardcode the ID for now
const GA_ID = 'G-QJHPRCJW8J';

// Hotjar tracking code
export const initHotjar = () => {
  if (isProduction) {
    (function(h,o,t,j,a,r){
      h.hj=h.hj||function(){(h.hj.q=h.hj.q||[]).push(arguments)};
      h._hjSettings={hjid:HOTJAR_ID,hjsv:6};
      a=o.getElementsByTagName('head')[0];
      r=o.createElement('script');r.async=1;
      r.src=t+h._hjSettings.hjid+j+h._hjSettings.hjsv;
      a.appendChild(r);
    })(window,document,'https://static.hotjar.com/c/hotjar-','.js?sv=');
  }
};

// Google Analytics tracking code
export const initGA = () => {
  if (isProduction) {
    // Add the script tag
    const script = document.createElement('script');
    script.async = true;
    script.src = `https://www.googletagmanager.com/gtag/js?id=${GA_ID}`;
    document.head.appendChild(script);

    // Initialize gtag
    /* eslint-disable-next-line no-unused-vars */
    window.dataLayer = window.dataLayer || [];
    function gtag() {
      // @ts-ignore
      window.dataLayer.push(arguments);
    }
    window.gtag = gtag; // Make gtag globally available
    gtag('js', new Date());
    gtag('config', GA_ID, {
      send_page_view: true,
      cookie_flags: 'SameSite=None;Secure'
    });
  }
};

// Track specific events
export const trackEvent = (category, action, label) => {
  if (isProduction && window.gtag) {
    window.gtag('event', action, {
      event_category: category,
      event_label: label
    });
  }
};

// Track page views
export const trackPageView = (path) => {
  if (isProduction && window.gtag) {
    window.gtag('config', GA_ID, {
      page_path: path
    });
  }
};

// Funnel events
export const trackFunnelStep = (step, additionalData = {}) => {
  if (isProduction && window.gtag) {
    window.gtag('event', step, {
      funnel_step: step,
      ...additionalData
    });
  }
};

// Predefined funnel steps
export const FUNNEL_STEPS = {
  LANDING_VIEW: 'landing_page_view',
  CUSTOMIZE_START: 'start_customization',
  CAR_SELECTED: 'car_model_selected',
  GRAPHIC_ADDED: 'graphic_added',
  CART_VIEW: 'cart_view',
  CHECKOUT_START: 'checkout_started',
  PURCHASE_COMPLETE: 'purchase_completed',
  CAR_SEARCH: 'car_search'
}; 